(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-blog-post';
  var sectionInstances = new WeakMap();

  function initSection(section) {
    if (!section || sectionInstances.has(section)) return;

    var track = section.querySelector('[data-blog-post-track]');
    var prevBtn = section.querySelector('[data-blog-post-prev]');
    var nextBtn = section.querySelector('[data-blog-post-next]');
    var progressFill = section.querySelector('[data-blog-post-progress]');

    if (!track) return;

    var autoplayEnabled = section.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = (parseInt(section.getAttribute('data-autoplay-speed'), 10) || 5) * 1000;
    var prefersReducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplayTimer = null;
    var userInteracted = false;
    var listeners = [];
    var resizeObserver = null;

    function addListener(target, event, handler, opts) {
      target.addEventListener(event, handler, opts);
      listeners.push({ target: target, event: event, handler: handler, opts: opts });
    }

    function getSlideWidth() {
      var firstCard = track.querySelector('.oddit-section-blog-post__card');
      if (!firstCard) return 0;
      var rect = firstCard.getBoundingClientRect();
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return rect.width + gap;
    }

    function updateProgress() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var allFit = maxScroll <= 1;
      var progress = allFit ? 0 : track.scrollLeft / maxScroll;
      // Fit-state fills to 100%; scrolling state starts at 38% and grows.
      var fillPercent = allFit ? 100 : 38 + progress * 62;
      if (progressFill) {
        progressFill.style.width = fillPercent + '%';
      }
      updateArrowStates(maxScroll, allFit);
    }

    function updateArrowStates(maxScroll, allFit) {
      if (prevBtn) {
        prevBtn.disabled = allFit || track.scrollLeft <= 1;
      }
      if (nextBtn) {
        nextBtn.disabled = allFit || track.scrollLeft >= maxScroll - 1;
      }
    }

    function scrollByDirection(direction) {
      var slideWidth = getSlideWidth();
      if (!slideWidth) return;
      track.scrollBy({
        left: slideWidth * direction,
        behavior: 'smooth'
      });
    }

    function autoplayStep() {
      if (userInteracted || document.hidden) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 1) return;
      if (track.scrollLeft >= maxScroll - 1) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        scrollByDirection(1);
      }
    }

    function startAutoplay() {
      if (!autoplayEnabled || prefersReducedMotion || autoplayTimer) return;
      autoplayTimer = window.setInterval(autoplayStep, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function handleUserInteraction() {
      userInteracted = true;
      stopAutoplay();
    }

    if (prevBtn) {
      addListener(prevBtn, 'click', function () {
        handleUserInteraction();
        scrollByDirection(-1);
      });
    }

    if (nextBtn) {
      addListener(nextBtn, 'click', function () {
        handleUserInteraction();
        scrollByDirection(1);
      });
    }

    addListener(track, 'scroll', updateProgress, { passive: true });
    addListener(track, 'wheel', handleUserInteraction, { passive: true });
    addListener(track, 'touchstart', handleUserInteraction, { passive: true });

    var dragCleanup = setupDrag(track, handleUserInteraction);

    updateProgress();

    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(function () {
        updateProgress();
      });
      resizeObserver.observe(track);
    }

    startAutoplay();

    sectionInstances.set(section, {
      destroy: function () {
        stopAutoplay();
        listeners.forEach(function (l) {
          l.target.removeEventListener(l.event, l.handler, l.opts);
        });
        listeners = [];
        if (dragCleanup) dragCleanup();
        if (resizeObserver) {
          resizeObserver.disconnect();
          resizeObserver = null;
        }
      }
    });
  }

  function destroySection(section) {
    if (!section) return;
    var instance = sectionInstances.get(section);
    if (instance && instance.destroy) {
      instance.destroy();
      sectionInstances['delete'](section);
    }
  }

  function setupDrag(track, onInteract) {
    var dragActive = false;
    var dragMoved = false;
    var startX = 0;
    var lastX = 0;

    function onPointerDown(e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      if (typeof e.button === 'number' && e.button !== 0) return;
      if (track.scrollWidth - track.clientWidth <= 1) return;
      dragActive = true;
      dragMoved = false;
      startX = e.clientX;
      lastX = e.clientX;
      track.classList.add('is-dragging');
      if (onInteract) onInteract();
    }

    function onPointerMove(e) {
      if (!dragActive) return;
      var dx = e.clientX - lastX;
      lastX = e.clientX;
      if (Math.abs(e.clientX - startX) > 4) dragMoved = true;
      track.scrollLeft -= dx;
    }

    function endDrag() {
      if (!dragActive) return;
      dragActive = false;
      track.classList.remove('is-dragging');
    }

    function onDragStart(e) {
      e.preventDefault();
    }

    function onClick(e) {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
        dragMoved = false;
      }
    }

    track.addEventListener('pointerdown', onPointerDown);
    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
    track.addEventListener('dragstart', onDragStart);
    track.addEventListener('click', onClick, true);

    return function cleanup() {
      track.removeEventListener('pointerdown', onPointerDown);
      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', endDrag);
      window.removeEventListener('pointercancel', endDrag);
      track.removeEventListener('dragstart', onDragStart);
      track.removeEventListener('click', onClick, true);
    };
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Shopify theme editor lifecycle.
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    var section = e.target.matches && e.target.matches(SECTION_SELECTOR)
      ? e.target
      : e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target) return;
    var section = e.target.matches && e.target.matches(SECTION_SELECTOR)
      ? e.target
      : e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
